import React, { useCallback } from "react";
import { connect } from "react-redux";

import useAutoRunning from "@app/component/flows/utils/useAutoRunning";
import Path from "@app/enum/Path";
import { getCurrentUser } from "@app/store/iam";
import { RootState } from "@app/store/rootReducer";

import ChecklistRunner from "../base/ChecklistRunner";

import { mapOnboardingConfiguration } from "./configuration";

export interface GettingStartedChecklistProps {}

const MapOnboarding = ({
  currentUser,
}: GettingStartedChecklistProps & ReturnType<typeof mapStateToProps>) => {
  const { handleHideConfirm, handleTourShow } = useAutoRunning(
    mapOnboardingConfiguration.id,
    currentUser,
    useCallback((pathname: string) => pathname.startsWith(Path.MAP), [])
  );

  return (
    <ChecklistRunner
      descriptor={mapOnboardingConfiguration}
      onHideConfirm={handleHideConfirm}
      onTourShow={handleTourShow}
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  currentUser: getCurrentUser(state)!,
});

export default connect(mapStateToProps)(MapOnboarding);
